export default __webpack_public_path__ + "static/404-1235daba488127002a94c9789e3cccfd.png";